import template from './step-5.html';

class StepFifthComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    SchoolCommonRoomService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.schoolCommonRoom) {
      this.schoolCommonRoom = {...this.schoolCommonRoom};
    }
  }
}

export const StepFifth = {
  bindings: {
    me: '<',
    schoolCommonRoom: '<'
  },
  template,
  controller: StepFifthComponent
};
